import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { TextureProvider } from './TextureContext';
import SignetStudio from '../Signet/Studio';
import DesignPatternStudio from '../DesignPattern/Studio';

const StudioWrapper = () => {
  return (
    <TextureProvider>
      <Switch>
        <Route path="/signet-studio" component={SignetStudio} />
        <Route path="/design-pattern-studio" component={DesignPatternStudio} />
      </Switch>
    </TextureProvider>
  );
};

export default StudioWrapper; 